@if (visible()) {
  <mat-progress-bar
    [mode]="mode()"
    [value]="progress()"
    [color]="'accent'"
  ></mat-progress-bar>
}
